module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Add new classifier","key":"Key","code":"Code","value":"Value"},"et":{"title":"Add new classifier","key":"Key","code":"Code","value":"Value"},"ru":{"title":"Add new classifier","key":"Key","code":"Code","value":"Value"}}')
  delete Component.options._Ctor
}
